import { getList } from '../../../lib/api';
import Legal from '@/components/legal';
import sleep from '@/plugins/sleep';
import $ from 'jquery';
import _ from 'lodash';
import { MAXIMUM_LIST_INDEX_NUM, FE_WORKSPACE_URI } from '../../../constants';
import scrollIntoView from 'scroll-into-view-if-needed';
import { Icon } from 'patsnap-biz';
import { Checkbox } from 'element-ui';
import numberFormat from '../../../utils/filters/number';
import CompareWithTag from '@/components/compare-with-tag/CompareWithTag';
import MultiMonitorToggle from '@/components/multi-monitors/MultiMonitorToggle';
import { usePatentsList } from './composables/use-patents-list';
import { getRouteNameList } from '@/router';
import '@patsnap-ui/icon/assets/solid/LoadingBars.svg';

function isElementInScrollViewport(el) {
    const rect = el.getBoundingClientRect();
    return rect.top >= 122 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight);
}
function scrollTopDelta(delta) {
    $('.patents-list-scroll').get(0).scrollTop += delta || 0;
}

export default {
    name: 'PatentList',
    components: {
        CompareWithTag,
        MultiMonitorToggle,
        Legal,
        PtIcon: Icon,
        ElCheckbox: Checkbox,
    },
    filters: { number: numberFormat },
    setup() {
        const {
            selectedPatentList,
            setSelectedPatent,
            isShowPatentList,
            idList,
            setIdList,
        } = usePatentsList();

        return {
            selectedPatentList,
            setSelectedPatent,
            isShowPatentList,
            idList,
            setIdList,
        };
    },
    data() {
        return {
            totalNumber: 1,
            totalApnoNumber: undefined,
            name: '',
            loadingNextVisible: false,
            dataList: [],
            hasPrev: true,
            loadingPrevVisible: false,
            hasNext: true,
            startIndex: 0,
            page: 1,
            prePage: 1,
            totalPages: 1,
            rows: 20,
            loadingList: true,
            isFirst: false,
            isLast: false,
            delay: {},
        };
    },
    props: {
        viewParams: {
            type: Object,
            required: true,
        },
        patentId: {
            type: String,
            required: true,
        },
    },
    computed: {
        hasSelectPatent() {
            return this.viewParams.source_type === 'innosnap';
        },
        selectedPatentIdList() {
            return this.selectedPatentList.map(({ PATENT_ID }) => PATENT_ID);
        },
    },
    methods: {
        isNumber: _.isNumber,
        findIndexByPatentId(patentId) {
            return _.findIndex(this.dataList, ({ PATENT_ID }) => PATENT_ID === patentId);
        },
        scrollToView(target, where) {
            if (!target || isElementInScrollViewport(target)) return;
            scrollIntoView(target, {
                scrollMode: 'if-needed',
                inline: 'start',
                block: where || 'nearest',
                behavior: 'instant',
            });
        },
        async readMe(patentId) {
            let index = this.findIndexByPatentId(patentId);
            if (index === -1) return;

            const pnInfo = this.dataList[index];
            pnInfo.READ_STATUS = 1;
            await sleep(); // 来不及渲染，在此停顿！
            const listScroll$ = $('.patents-list-scroll');
            const target = listScroll$.find(`[data-patentid=${patentId}]`).get(0);

            // 如果点击当前page的第一条，需触发上一页
            if (this.prePage > 1 && index === 0) {
                await this.loadList('prev');
                // 收缩状态调用scrollToView会有bug
                if (this.isShowPatentList) {
                    await sleep();
                    this.scrollToView(target, 'start');
                    await sleep();
                    scrollTopDelta(-35); // 35 是上一页按钮高度
                }
            } else {
                // 收缩状态调用scrollToView会有bug
                if (this.isShowPatentList) this.scrollToView(target);
            }

            // 更新上一页下一页状态
            index = this.findIndexByPatentId(patentId);
            this.isFirst = (index === 0);
            this.isLast = (this.page >= this.totalPages && index >= this.dataList.length - 1);

            if (pnInfo.onPage) {
                sessionStorage.setItem(`listOnPage:${pnInfo.PATENT_ID}`, pnInfo.onPage);
            }
        },
        loadPrev({ list = [], page, rows }) {
            this.dataList = Object.preventExtensions(list.concat(this.dataList));
            this.loadingPrevVisible = false;
            this.startIndex = (page - 1) * rows;
            this.rows = rows;
        },
        loadNext({ list = [] }) {
            this.dataList = Object.preventExtensions(this.dataList.concat(list));
            this.loadingNextVisible = false;
        },
        loadInit({ list = [], page, rows, totalNumber, totalPages }) {
            this.dataList = list;
            if (totalPages === page) {
                this.hasNext = false;
                $('.patents-list-scroll').off('scroll');
            }
            if (totalNumber === this.dataList.length) {
                this.hasPrev = false;
            }
            this.startIndex = (page - 1) * rows;
            this.rows = rows;
        },
        async deletePatentFromList(patentId, isFamilyType) {
            if (isFamilyType) {
                await this.loadList('init');
                // empty folder
                if (!this.dataList.length) {
                    if (!this.viewParams.workspace_id || !this.viewParams.folder_id) return;
                    window.location.href = `${FE_WORKSPACE_URI}/detail/patent/folders?spaceId=${this.viewParams.workspace_id}&folderId=${this.viewParams.folder_id}&page=1`;
                }
                const firstPatentId = this.dataList[0].PATENT_ID;
                this.page = 1;
                let query = { ...this.$route.query, patentId: firstPatentId, page: this.page };
                const listScroll$ = $('.patents-list-scroll');
                const target = listScroll$.find(`[data-patentid=${firstPatentId}]`).get(0);
                this.scrollToView(target);
                this.$router.replace({ query, params: { ...this.$route.params } });
            } else {
                const nextId = this.getNextPatent(patentId);
                this.dataList = Object.preventExtensions(_.reject(this.dataList, { PATENT_ID: this.patentId }));
                this.totalNumber -= 1;
                if (nextId) {
                    this.switchPatent(nextId);
                } else {
                    // empty folder
                    if (!this.viewParams.workspace_id || !this.viewParams.folder_id) return;
                    window.location.href = `${FE_WORKSPACE_URI}/detail/patent/folders?spaceId=${this.viewParams.workspace_id}&folderId=${this.viewParams.folder_id}&page=1`;
                }
            }
        },
        async loadList(type) {
            if (type === 'prev') {
                this.prePage = parseInt(this.prePage) - 1;
                this.loadingPrevVisible = true;
            }
            if (type === 'next') {
                this.page = parseInt(this.page) + 1;
                this.loadingNextVisible = true;
            }
            // 请求参数
            const options = _.clone(this.viewParams);
            options.page = (type === 'prev') ? this.prePage : this.page;
            if (options.q) options.q = options.q.replace('$/', '#/');

            if (options.imageId) {
                let shape_based_first = false;
                try {
                    shape_based_first = JSON.parse(localStorage.getItem('IMAGE_SEARCH_SHAPE_FIRST')) || false;
                } catch (error) {
                    console.log(error);
                }
                options.shape_based_first = shape_based_first;
            }
            // 返回值
            const res = await getList(options);
            const { name, LIST: list, page, rows, totalNumber, totalPages, totalApnoNumber } = _.get(res, 'data', {});
            // 上限处理
            if (!list && (this.rows * this.page >= MAXIMUM_LIST_INDEX_NUM)) {
                // 这货居然翻了一万条上限还没找到想要的，真可怜😢。。。
                this.loadingList = false;
                this.hasNext = false;
                this.loadingNextVisible = false;
                return;
            }
            // 触发对应分页方法
            switch (type) {
                case 'init':
                    this.loadInit({ list, page, rows, totalNumber, totalPages });
                    this.readMe(this.patentId);
                    break;
                case 'prev':
                    this.loadPrev({ list, page, rows });
                    break;
                case 'next':
                    this.loadNext({ list });
                    break;
                default:
                    break;
            }
            // 更新依赖数据
            this.name = name;
            this.totalNumber = totalNumber;
            this.totalApnoNumber = totalApnoNumber;
            this.totalPages = totalPages;
            this.loadingList = false;
            this.loadingPrevVisible = false;
            this.loadingNextVisible = false;
            if (this.prePage === 1) this.hasPrev = false;
            if (page >= totalPages) this.hasNext = false;
        },
        scrollInit() {
            this.$nextTick(() => {
                const listContent$ = $('.patents-list-content');
                const listScroll$ = $('.patents-list-scroll');
                const onScroll = _.debounce(() => {
                    if (!this.loadingNextVisible) {
                        const _contentHeight = listContent$.height();
                        const _scrollTop = listScroll$.scrollTop();
                        const _viewHeight = listScroll$.height();
                        if (_scrollTop + _viewHeight + 200 >= _contentHeight && this.hasNext) {
                            this.loadList('next');
                        }
                    }
                }, 500);
                listScroll$.on('scroll', onScroll);
            });
        },
        getRouterLink(data) {
            // 如果是workspace跳转过来需要动态更新bio_uk 其他保持原样
            const isFromWorkspace = this.viewParams.source_type === 'workspace';
            const bio_uk = _.get(data, 'BIO_UK[0]', '');
            let query = {};
            if (isFromWorkspace) {
                query = { ...this.$route.query, patentId: data.PATENT_ID, page: data.onPage, bio_uk };
            } else {
                query = { ...this.$route.query, patentId: data.PATENT_ID, page: data.onPage };
            }
            return { query, params: this.$route.params };
        },
        linkToInnosnap() {
            const targetLink = this.viewParams.innosnap_redirect;
            const selectedIds = this.selectedPatentIdList.join(',');
            console.log(`targetLink=${targetLink} +++++++++ selectedIds=${selectedIds}`);
        },
        switchDelay(patentId, direction) {
            clearTimeout(this.delay);
            this.delay = setTimeout(() => {
                this.switchPatent(patentId, direction);
            }, 400);
            window.rvTrack('Click Patent Up Down Switch', {
                source: getRouteNameList(this.$route),
                type: direction === '-1' ? 'up' : 'down',
            });
        },
        switchPatent(patentId, direction = 0) {
            // todo zhaobiao  direction = 1 go next patent, -1 go prev patent
            const currentIndex = _.findIndex(this.idList, itemId => itemId === patentId);
            const lastIndex = this.idList.length - 1;
            const targetIndex = currentIndex + direction;
            if (targetIndex > lastIndex || targetIndex < 0) {
                return false;
            }

            // 如果是workspace跳转过来需要动态更新bio_uk 其他保持原样
            const newPatentId = this.idList[targetIndex];
            const isFromWorkspace = this.viewParams.source_type === 'workspace';
            const bio_uk = _.get(this.dataList.find(item => item.PATENT_ID === newPatentId), 'BIO_UK[0]', '');
            let query = {};
            if (isFromWorkspace) {
                query = { ...this.$route.query, patentId: newPatentId, bio_uk };
            } else {
                query = { ...this.$route.query, patentId: newPatentId };
            }

            this.$router.push({ query, params: { ...this.$route.params } });
            return true;
        },
        getNextPatent(patentId) {
            const currentIndex = _.findIndex(this.idList, itemId => itemId === patentId);
            const lastIndex = this.idList.length - 1;
            if (this.idList.length <= 1) {
                return null;
            }
            let targetIndex = currentIndex + 1;
            if (targetIndex > lastIndex) {
                targetIndex = currentIndex - 1;
            }
            return this.idList[targetIndex];
        },
    },
    created() {
        const { page, related_id: relatedId } = this.viewParams;
        this.$eventHub.$on('PATENT_DELETE', this.deletePatentFromList);
        this.hasMark = !_.get(window, 'zPREFACE.globalConfig.userInfo.isSpecialIp');
        this.page = page;
        this.prePage = page;
        this.loadList('init').then(() => {
            if (relatedId) {
                const i = this.findIndexByPatentId(this.patentId);
                const targetPatentId = _.get(this, 'dataList.0.PATENT_ID');
                if (i < 0 && targetPatentId) {
                    this.$router.replace({ query: { ...this.$route.query, patentId: targetPatentId }, params: { ...this.$route.params } });
                }
            }
        });
    },
    mounted() {
        this.scrollInit();
    },
    watch: {
        isShowPatentList() {
            setTimeout(() => {
                if (this.patentId) {
                    this.readMe(this.patentId);
                }
            }, 600);
        },
        dataList(list) {
            this.setIdList(_.map(list, item => item.PATENT_ID));
        },
        patentId(newId) {
            this.readMe(newId);
        },
        isFirst(val) {
            this.$emit('pageInfoUpdate', { type: 'isFirst', value: val });
        },
        isLast(val) {
            this.$emit('pageInfoUpdate', { type: 'isLast', value: val });
        },
    },
};
